import React from "react";
import RichTextEditor from "react-rte";
import _ from "lodash";
const { useState } = React;

const parentClassname = "react-form";

const RTE = props => {
    const componentClassname = parentClassname
        ? `${parentClassname}__field`
        : "field";

    const labelPlaceholderClassname = props.labelplaceholder
        ? `${componentClassname}__label--labelplaceholder`
        : "";

    const hasErrors =
        !props.hideErrors &&
        props.errors &&
        props.errors.length &&
        props.showErrors;

    const maxRegex = /max-(\d+)/i;
    const maxMatch = props.className && props.className.match(maxRegex);

    const [content, setContent] = useState(
        RichTextEditor.createValueFromString(props.value, "html")
    );

    const handleEditorChange = content => {
        setContent(content);
        if (props.onChange) {
            props.onChange({
                target: {
                    value: content.toString("html"),
                    name: props.name,
                },
            });
        }
    };

    return (
        <div
            className={`${componentClassname} 
				${componentClassname}--${props.type}
				${props.classes.inheritedClasses} 
				${props.classes.isDisabled} 
				${props.classes.isIncomplete} 
				${props.classes.isFocused} 
				${props.classes.hasValue}
				${props.classes.isValid}
                ${props.classes.isInvalid}
                ${props.checked ? "is-checked" : ""}
			`}
        >
            <label htmlFor={props.accessibilityIds.input}>
                {/*label*/}
                {props.label ? (
                    <div
                        className={`${componentClassname}__label  ${labelPlaceholderClassname} ${parentClassname}__label-title`}
                    >
                        <div
                            className={`${componentClassname}__label__inner`}
                            id={props.accessibilityIds.label}
                        >
                            {props.label}
                            {props.required ? null : !props.hideOptional ? (
                                <span
                                    className={`${componentClassname}__label__optional-label`}
                                ></span>
                            ) : null}
                        </div>
                    </div>
                ) : null}
                {/*info*/}
                {props.info ? (
                    <div
                        className={`${componentClassname}__info ${parentClassname}__label-description`}
                        id={props.accessibilityIds.description}
                    >
                        {props.info}
                    </div>
                ) : null}
                <div
                    className={`${componentClassname}__input-container ${
                        props.icon ? "has-icon" : ""
                    }`}
                >
                    {props.icon ? (
                        <label
                            htmlFor={props.accessibilityIds.input}
                            className={`${componentClassname}__input-icon`}
                        >
                            <i className={`icon icon-${props.icon}`}></i>
                        </label>
                    ) : null}
                    {/*input element*/}
                    <RichTextEditor
                        className={`${componentClassname}__rte`}
                        value={content}
                        onChange={handleEditorChange}
                        ref={input => {
                            props.inputElement.ref.current = _.get(
                                input,
                                "refs.editor.editor",
                                null
                            );
                        }}
                        onFocus={() => {
                            props.onFocus &&
                                props.onFocus({
                                    target: {
                                        value: content.toString("html"),
                                        name: props.name,
                                    },
                                });
                        }}
                        onBlur={() => {
                            props.onBlur &&
                                props.onBlur({
                                    target: {
                                        value: content.toString("html"),
                                        name: props.name,
                                    },
                                });
                        }}
                    />
                    {/* Error icon */}
                    {hasErrors ? (
                        <div className={`${componentClassname}__error-icon`}>
                            <i className="icon icon-alert-triangle"></i>
                        </div>
                    ) : null}
                </div>
                {maxMatch && (
                    <div className={`${componentClassname}__counter`}>
                        {props.inputElement.props.value.length} / {maxMatch[1]}
                    </div>
                )}
            </label>

            {/*errors*/}
            {hasErrors ? (
                <div className={`${componentClassname}__errors`}>
                    <div
                        className={`${componentClassname}__errors__item`}
                        id={props.accessibilityIds.error}
                    >
                        Error: {props.errors[0]}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default RTE;
